<template>
    <GuestLayout>
        <FullscreenLoading v-if="isLoading" />

        <div class="container-fluid d-flex flex-column">
            <div class="row justify-content-center min-vh-100">
                <div class="col-md-6 col-lg-5 col-xl-4 py-6 py-md-0 mt-10">
                    <div class="card" style="max-width: 600px; margin: 0 auto;">
                        <div class="d-flex justify-content-end mr-2 mt-1">
                            <LanguageSwitcher />
                        </div>

                        <div class="card-body">
                            <div class="card-header text-center mb-5">
                                <img src="../../assets/lite/Logo-Text-Below.svg" style="height: 140px;" />
                            </div>

                            <div v-if="successMessage" class="alert alert-success">
                                {{ successMessage }}
                            </div>

                            <div>
                                <LoginForm id="login-form" :initial-values="loginValues" @submit="login" />

                                <div class="mt-4">
                                    <button type="submit" form="login-form" class="btn btn-block btn-primary">{{ $t('register.login_link') }}</button>
                                </div>

                                <div class="mt-3 text-center">
                                    <router-link :to="{ name: 'register' }">{{ $t('register.register_link') }}</router-link>
                                    |
                                    <router-link :to="{ name: 'forgot-password' }">{{ $t('register.forgot_password_link') }}</router-link>
                                </div>

                                <div class="alert alert-danger mt-5" v-if="errorMessage">{{ errorMessage }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </GuestLayout>
</template>
<script>

    import { mapState } from 'vuex';
    import { IpcCall, ipcCall } from '../utils/ipcCall';
    import LoginForm from '../../forms/LoginForm.vue';
    import GuestLayout from './GuestLayout.vue';
    import FullscreenLoading from '../../components/FullscreenLoading.vue';
    import i18n from '../../utils/locale';
    import LanguageSwitcher from '../../components/LanguageSwitcher.vue';

    export default {
        components: {
            GuestLayout,
            LoginForm,
            FullscreenLoading,
            LanguageSwitcher,
        },

        computed: {
            successMessage() {
                if (Object.hasOwn(this.$route.query, 'deleted_account')) {
                    return this.$t('account.delete_account_success');
                }

                return null;
            },

            ...mapState({
                user: state => state.user,
            }),
        },

        data() {
            return {
                isLoading: false,
                errorMessage: null,
                loginValues: {
                    email: null,
                    password: null,
                },
            };
        },

        methods: {
            async login(data) {
                this.isLoading = true;
                this.errorMessage = null;

                try {
                    const response = await ipcCall(IpcCall.Login, data);

                    await this.$store.dispatch('login', {
                        user: response,
                        token: response.id,
                    });

                    await this.$store.dispatch('setLocations', response.company?.locations || []);

                    await this.$router.push({
                        name: 'ceremonies',
                    });
                } catch (exception) {
                    this.errorMessage = exception?.message || i18n.t('general.something_went_wrong');
                } finally {
                    this.isLoading = false;
                }
            },
        },
    };

</script>
